import React from 'react';
import styles from './PlayToWinPage.module.css';

const PlayToWinPage = () => {
  return (
    <div className={styles.playtowinPageContainer}>
      <div className={styles.playtowinContentWrapper}>
        <div className={styles.playtowinHeaderSection}>
          <h1 className={styles.playtowinMainTitle}>Play to Win</h1>
          <p className={styles.playtowinSubtitle}>Exciting games and prizes coming soon!</p>
        </div>
        <div className={styles.playtowinBody}>
          <div className={styles.playtowinPlaceholder}>
            <div className={styles.playtowinIcon}>🎮</div>
            <h2>Coming Soon!</h2>
            <p>We're working on bringing you exciting games and amazing prizes. Stay tuned!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayToWinPage;
